import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class PHANTOMGOLD extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">PHANTOM GOLD +</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li>
              <span className="label">
                1. Gazette Notification number and Date:
              </span>{' '}
              S.O.876(E) Dated 16-02-2026
            </li>

            <li>
              <span className="label">
                2. Title of Biostimulant:
              </span>{' '}
              (3) Folic acid 0.1% (Liquid)
            </li>

            <li>
              <span className="label">3. Composition:</span>
              <ul>
                <li>
                  (i) Folic acid per cent. by weight, minimum: 0.1
                </li>
                <li>
                  (ii) Polysorbate 20 per cent. by weight, maximum: 3.0
                </li>
                <li>
                  (iii) Sodium bicarbonate per cent. by weight, maximum: 2.5
                </li>
                <li>
                  (iv) Water per cent. by weight: QS
                </li>
                <li>
                  (v) Total (per cent.): 100.0
                </li>
              </ul>
            </li>

            <li>
              <span className="label">4. Crop:</span> Chilli
            </li>

            <li>
              <span className="label">5. Doses:</span>
              <ul>
                <li>
                  (i) Chilli: Four foliar applications at 200 ml/ha.
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li>
              <span className="label">
                1. गजट नोटिफिकेशन नंबर और तारीख:
              </span>{' '}
              S.O.876(E) तारीख 16-02-2026
            </li>

            <li>
              <span className="label">
                2. जैव-उत्तेजक का टाइटल:
              </span>{' '}
              (3) फोलिक एसिड 0.1% (तरल)
            </li>

            <li>
              <span className="label">3. संरचना :</span>
              <ul>
                <li>
                  (i) फोलिक एसिड परसेंट. वज़न के हिसाब से, कम से कम: 0.1
                </li>
                <li>
                  (ii) पॉलीसोर्बेट 20 parsent. वज़न के हिसाब से, ज़्यादा से ज़्यादा: 3.0
                </li>
                <li>
                  (iii) सोडियम बाइकार्बोनेट परसेंट. वज़न के हिसाब से, ज़्यादा से ज़्यादा: 2.5
                </li>
                <li>
                  (iv) पानी परसेंट. वज़न के हिसाब से: QS
                </li>
                <li>
                  (v) टोटल (परसेंट): 100.0
                </li>
              </ul>
            </li>

            <li>
              <span className="label">4. फसल:</span> मिर्च
            </li>

            <li>
              <span className="label">5. डोज़:</span>
              <ul>
                <li>
                  (i) मिर्च: 200 मिली./हैक्टेयर के हिसाब पत्तियों पर चार छिड़काव डालें।
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li>
              <span className="label">
                १. राजपत्र अधिसूचना क्रमांक आणि दिनांक:
              </span>{' '}
              एस.ओ.८७६(ई) दिनांक १६-०२-२०२६
            </li>

            <li>
              <span className="label">
                २. जैवउत्तेजकाचे नाव:
              </span>{' '}
              (३) फॉलिक ॲसिड ०.१% (द्रव)
            </li>

            <li>
              <span className="label">३. रचना:</span>
              <ul>
                <li>
                  (i) फॉलिक ॲसिड वजनानुसार टक्केवारी, किमान: ०.१
                </li>
                <li>
                  (ii) पॉलिसॉर्बेट २० वजनानुसार टक्केवारी, कमाल: ३.०
                </li>
                <li>
                  (iii) सोडियम बायकार्बोनेट वजनानुसार टक्केवारी, कमाल: २.५
                </li>
                <li>
                  (iv) पाणी वजनानुसार टक्केवारी: आवश्यक (QS)
                </li>
                <li>
                  (v) एकूण (टक्केवारी): १००.०
                </li>
              </ul>
            </li>

            <li>
              <span className="label">४. पीक:</span> मिरची
            </li>

            <li>
              <span className="label">५. मात्रा:</span>
              <ul>
                <li>
                  (i) मिरची: २०० मिली/हेक्टर या प्रमाणात चार वेळा फवारणी.
                </li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}